package es.subastia.navigation

sealed interface NavRoute {
    data object Splash : NavRoute
    data object Main : NavRoute
    data object SavedSearches : NavRoute
    data object Favorites : NavRoute
    data object Profile : NavRoute

    data class AuctionList(
        val query: String? = null,
        val type: String? = null,
        val procedureType: String? = null,
        val province: String? = null
    ) : NavRoute
    data object AuctionFilter : NavRoute
    data class AuctionDetail(val id: String) : NavRoute
    data class Gallery(val imageUrl: String) : NavRoute
}
